import { loadState } from './localStore';
export const TOKEN_KEY = 'token';
const getToken = () => loadState(TOKEN_KEY) || null;
export default function request(method, domain, url, data = {}) {
    const token = getToken();
    return fetch(`${domain}${url}`, {
        method,
        headers: token && {
            Authorization: `Bearer ${token}`,
        },
        body: data && JSON.stringify(data),
    }).then(response => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    });
}
export function get(domain, url, data = null) {
    return request('GET', domain, url, data).then(res => res.json());
}
export function put(url, data = {}, domain) {
    return request('PUT', domain, url, data).then(res => res.json());
}
export function post(url, data = {}, domain) {
    return request('POST', domain, url).then(res => res.json());
}
//# sourceMappingURL=request.js.map